<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="店铺名称" v-if="stoId==0" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="用户手机号" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.phone" placeholder="请输入用户手机号">
						</el-input>
					</el-form-item>
					<el-form-item label="卡项名称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.cardName" placeholder="请输入卡项名称">
						</el-input>
					</el-form-item>
					<el-form-item label="卡项类别" class='tiny'>
						<el-select v-model="orderInfo.cardType"  style="width: 120px;">
							<el-option key="-1" label="全部" value="">全部</el-option>	
							<el-option  key="1" :value="1" label="会员卡">会员卡</el-option>
							<el-option key="2" :value="2"	 label="次卡">次卡</el-option>
							<el-option key="3" :value="3" label="包年包月卡">包年包月卡</el-option>
						</el-select>
					</el-form-item>
					
					
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status"  style="width: 100px;">
							<el-option key="-1" label="全部" value="">全部</el-option>	
							<el-option :value="1" label="启用">启用</el-option>
							<el-option :value="0" label="停用">停用</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="是否默认卡项" class='tiny'>
						<el-select v-model="orderInfo.isDefault" style="width: 100px;">
							<el-option key="-1" label="全部" value="">全部</el-option>	
							<el-option value="true" label="是">是</el-option>
							<el-option value="false" label="否">否</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="是否可以多张" class='tiny'>
						<el-select v-model="orderInfo.isRepeat">
							<el-option value="true" label="是">是</el-option>
							<el-option value="false" label="否">否</el-option>
						</el-select>
					</el-form-item> -->
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button v-if="stoId!=0" type="primary" @click="editialogVisible()">开卡</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="卡项名称">
							<span>{{ props.row.cardName }}</span>
						</el-form-item>
						
						<el-form-item label="单价(元)">
							<span>{{props.row.price?props.row.price:'免费'}}</span>
						</el-form-item>
					
						<el-form-item label="卡项总次数" v-if="props.row.cardType!=1">
							<span>{{props.row.totalTimes==0?'无限次数':props.row.totalTimes}}</span>
						</el-form-item>
						<el-form-item label="卡项剩余次数" v-if="props.row.cardType!=1" >
							<span>{{props.row.leftTimes==0?'无限次数':props.row.leftTimes}}</span>
						</el-form-item>
						
					</el-form>
				</template>
			</el-table-column>
			
			<el-table-column prop="storeName" v-if="stoId==0"  label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="会员信息" align="center" width="200" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<span>{{ scope.row.userId }}</span>
					<span v-if="scope.row.username">~{{ scope.row.username }}</span>
					<span v-if="scope.row.phone">~{{ scope.row.phone }}</span>
				</template>
				
			</el-table-column>
			<el-table-column prop="cardName" label="卡项名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="cardType" label="卡项类别" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.cardType==1">会员卡</span>
					<span v-if="scope.row.cardType==2">次卡</span>
					<span v-if="scope.row.cardType==3">包年包月卡</span>
					
				</template>
			</el-table-column>
			<el-table-column prop="price" label="单价(元)" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.price?scope.row.price:'免费'}}</span>
				</template>
					
			</el-table-column>
			<el-table-column prop="discount" label="卡项折扣" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.discount?scope.row.discount:'无折扣'}}
				</template>
			</el-table-column>
		
			<el-table-column prop="beginDate" label="有效期开始时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="beginDate" label="有效期(天)" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.validityDay==0?'长期有效':scope.row.validityDay}}
				
				</template>
			</el-table-column>
			
			
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==true">启用</span>
					<span v-if="scope.row.status==false">停用</span>
				</template>
			</el-table-column>
			<el-table-column prop="createBy" label="开卡操作人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="createDate" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateDate" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right"    align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row)">续卡</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>　
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>


		<!-- 开卡 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose" width="600px"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo" style="margin-right:30px;">
					<el-form-item  label="会员手机号" label-width="90px">
						<el-input  type="text"  v-model="storeGoodsInfo.phone" style="width: 100%;"
							auto-complete="off" placeholder="请输入会员手机号" v-if="title=='开卡'"/>
						<el-input  type="text"  v-model="storeGoodsInfo.phone" style="width: 100%;"
							auto-complete="off" placeholder="请输入会员手机号" v-else disabled/>
					</el-form-item>

					<el-form-item label="推荐人" label-width="90px">
						<el-select filterable   v-model="storeGoodsInfo.referrerId"  placeholder="请选择推荐人" 
							clear 
							style="width: 100%;">
							<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.realname">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="选择卡项" label-width="90px">
						<el-select v-model="storeGoodsInfo.cardId" @change="change" style="width: 100%;">
							<el-option v-for="item in KxList" :key="item.id" :value="item.id" :label="item.cardName">{{item.cardName}}</el-option>
						</el-select>
					
					</el-form-item>
					<div v-if="storeGoodsInfo.cardId">
						
						<el-form-item label="单价  (元)">
							{{sInfo.price}}
						</el-form-item>
						<el-form-item label="有效时长(天)">
							{{sInfo.validityDay}}
						</el-form-item>
						<!-- <el-form-item v-if="sInfo.cardType==3" label="是否限制次数" class="redItem">
							{{sInfo.isCardTimes}}
							</el-switch>
						</el-form-item> -->
						
						<el-form-item label="使用次数" v-if="sInfo.cardType==2">
							{{sInfo.cardTimes}}
						</el-form-item>
						<el-form-item label="使用次数" v-if="sInfo.cardType==3&&sInfo.isCardTimes">
							{{sInfo.cardTimes}}
						</el-form-item>
						<el-form-item label="卡项类别">
							{{sInfo.cardType==1?'会员卡':sInfo.cardType==2?'次卡':'包年包月卡'}}
							
						</el-form-item>
						<el-form-item v-if="sInfo.cardType==1" label="卡项折扣(例0.88为88折)">
							{{sInfo.discount}}
						</el-form-item>
					</div>
						
				
					
					
					<!-- <el-form-item label="是否默认开卡项" class="redItem">
						<el-switch v-model="sInfo.isDefault" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item> -->
					<div style="display: flex;justify-content: space-between;">
						
						<el-form-item label="赠送数量" v-if="sInfo.isRewardIntegral" class="redItem">
							赠送{{sInfo.rewardIntegralNum}}{{sInfo.integralName}}
							（剩余{{inUseCnt}}{{sInfo.integralName}}）
						</el-form-item>
					</div>
					
					<el-button type="primary" v-if="title=='新增卡项'" @click="sure" style="margin-top: 100px;"
					:loading="sureLoading">提交</el-button>
					<el-button type="primary" v-else @click="submit" style="margin-top: 100px;"
					:loading="submitLoading">编辑</el-button>
				</el-form>
			</div>
		</el-dialog>


		<!-- 续卡 -->
		
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('card');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				sInfo:{},
				storeLoading:false,
				accountList:[],
				stoId:'',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				tableData:[
					{
						levelName:'',
						orderIndex:'',
						status:false
					}
				],
				sliderlist:{},
				expressList: [],
				orderInfo: {
					cardType: '',
					status: '',
					isDefault: ''
				},
				storeGoodsInfo: {
					isRewardIntegral:false,
					isRepeat:false,
					isDefault:false,
					isCardTimes:false
				},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				title:'',
				KxList:[],
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},

				sureLoading: false,
				submitLoading: false,


				inUseCnt: 0,
			}
		},
		methods: {
			sure(){
				this.sureLoading = true;
				this.$api.adderpCardUser({...this.storeGoodsInfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							isRewardIntegral:false,
							isRepeat:false,
							isCardTimes:false,
							isDefault:false,}
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})
			},
			del(it){
				this.tableData.splice(it,1)
				
			},
			add(){
				this.tableData.push({
					levelName:'',
					orderIndex:'',
					status:false
				})
			},
			addDialogClose(){
				this.dialogVisibleSwiper=false
			},
		
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			getUserList(e) {
				this.$api.queryManageUserWhere({
					supplierId: 0
				}).then((res) => {
					console.log('推荐人---',res);
					if (res.state == 'success') {
						this.accountList = res.data
					}else{
						this.$message.error(res.message);
					}
				})
				
			},
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					...this.orderInfo
				}
				this.$api.erpCardUser(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
		

			// 提交
			submit() {
				this.submitLoading = true;
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.adderpCardUser(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							isRewardIntegral:false,
							isRepeat:false,
							isDefault:false,
							isCardTimes:false,
						}
					} else {
						this.$message.error(res.message);
					}
					this.submitLoading = false;
				})

			},
			// 开卡、续卡
			editialogVisible(item) {
				this.dialogVisibleSwiper=true
				if(item){
					
					this.title='续卡'
					this.storeGoodsInfo.phone = item.phone;
				}else{
					this.title='开卡'
					this.storeGoodsInfo = {
						isRewardIntegral:false,
						isRepeat:false,
						isDefault:false,
						isCardTimes:false
					}
					
				}
				
				
			
				
			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该卡项, 是否继续?"
				}else{
					var str = "此操作将启用该卡项, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.statusCardUser(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			change(e){
				this.sInfo=this.KxList.find(item=>item.id==e)

				this.$api.getPropertyByIntegral(e).then((res) => {
					if (res.state == 'success') {
						this.inUseCnt=res.data.data.inUseCnt
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该卡项, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delCardUser(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()
			this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('登录人信息---', res.data )
					// supplierId(有值就是供应商)
					this.stoId = res.data.storeId; // storeId：0(平台)   
					
				}
			})
			this.$api.finderpCard({}).then(res=>{
				console.log(res);
				this.KxList=res.data.list
			})

			this.getUserList()
		}
	}
</script>

<style>

</style>
